import { render, staticRenderFns } from "./ClientSales.vue?vue&type=template&id=6fa27140&"
import script from "./ClientSales.vue?vue&type=script&lang=js&"
export * from "./ClientSales.vue?vue&type=script&lang=js&"
import style0 from "./ClientSales.vue?vue&type=style&index=0&id=6fa27140&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports